import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { forkJoin } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ChipModule } from 'primeng/chip';
import { InputSwitchModule } from 'primeng/inputswitch';

import { Road } from '../../select-road/models/select-road.model';
import { SelectRoadService } from '../../select-road/services/select-road.service';
import { StorageService } from '../../../core/services/storage.service';
import { CommunicationsService } from './services/communications.service';
import { Communication } from './models/communication.model';
import { StateService } from '../../../core/services/state.service';
import { Status } from '../../../shared/constants/response-results';
import { UtilsService } from '../../../core/services/utils.service';

@Component({
  selector: 'app-kit-add',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    DropdownModule,
    DynamicDialogModule,
    InputTextModule,
    RadioButtonModule,
    ChipModule,
    InputSwitchModule,
  ],
  templateUrl: './communications.component.html',
})
export class CommunicationsComponent implements OnInit {
  kitForm!: FormGroup;

  selectedRoad: Road | null = null;

  ref: DynamicDialogRef | undefined;

  checkedMock1: boolean = false;
  checkedMock2: boolean = false;

  communications: Communication[] = [];
  originalCommunications = new Map<string, boolean>();

  constructor(
    public dialogService: DialogService,
    public config: DynamicDialogConfig,
    public roadService: SelectRoadService,
    public storageService: StorageService,
    public dialogRef: DynamicDialogRef,
    public communicationsService: CommunicationsService,
    public stateService: StateService,
    private utilsService: UtilsService
  ) {}
  ngOnInit(): void {
    this.selectedRoad = this.stateService.getCurrentSelectedRoad();

    this.communicationsService.getCommunications(this.selectedRoad!.id).subscribe({
      next: (res) => {
        this.communications = res;
        this.originalCommunications = new Map(
          res.map((communication) => [communication.system, communication.enabled]),
        );
      },
      error: (error) => {
        console.log(error);
        this.ref = this.utilsService.showResponseResult(
          'Ha habido un error al obtener las comunicaciones',
          Status.ERROR,
        );
      },
    });

    this.communicationsService.getCommunications(this.selectedRoad!.id).subscribe((res) => {
      this.communications = res;
      this.originalCommunications = new Map(
        res.map((communication) => [communication.system, communication.enabled]),
      );
    });
  }

  saveCommunications() {
    const modifiedCommunications = this.communications.filter(
      (communication) =>
        this.originalCommunications.get(communication.system) !== communication.enabled,
    );

    if (!modifiedCommunications.length) {
      return;
    }

    forkJoin(
      modifiedCommunications.map((communication) =>
        this.communicationsService.patchCommunications(
          this.selectedRoad!.id,
          communication.system,
          communication.enabled,
        ),
      ),
    ).subscribe({
      next: (res) => {
        this.closeDialog();
      },
      error: (error) => {
        console.log(error);
        this.utilsService.showResponseResult('Error al actualizar las comunicaciones', Status.ERROR);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
